App.ClientTagComponent = Em.Component.extend
  classNames: 'client-tag'
  clientTag: null

  actions:
    remove: ->
      @sendAction 'onRemove', @get('clientTag')